import back_arrow from "../assets/backarrow.svg";
import filter from "../assets/filter-icon.svg"
import filter_arrow from "../assets/filter-arrow.svg"
import {useNavigate, useParams} from "react-router-dom";
import ROITitleCard from "../components/ROITitleCard";
import ROIGraphical from "../components/ROIGraphical";
import {useEffect, useState} from "react";
import reports_api from "../api/protected/reports"
import comments_api from "../api/protected/comments"
import ROITabular from "../components/ROITabular";
import ROIBarChart from "../components/ROIBarChart";
import ROICoachPerformance from "../components/ROICoachPerformance";
import ROIFilterOrganisationRow from "../components/ROIFilterOrganisationRow";
import CoachCommentaryContainer from "../components/CoachCommentaryContainer";
import ROIReportConfigurator from "../components/ROIReportConfigurator";
import pdf_download from "../assets/download-pdf-temp.png";
import { captureElementAsCanvas, canvasToA4PdfDataUri, waitForLayout } from "../utils/captureForPdf";
import info from "../assets/info-icon.png";
import profile_api from "../api/protected/profile";


const ROIReport = () => {

    const navigate = useNavigate()
    const params = useParams()

    const [selectedTeams, setSelectedTeams] = useState([])
    const [graphicalData, setGraphicalData] = useState([])
    const [tabularData, setTabularData] = useState([])
    const [barChartData, setBarChartData] = useState([])
    const [titleData, setTitleData] = useState(null)
    const [coachData, setCoachData] = useState(null)
    const [filterList, setFilterList] = useState([])
    const [filterSelected, setFilterSelected] = useState([])
    const [selectState, setSelectState] = useState(0)
    const [benchmark, setBenchmark] = useState([0, 0, 0, 0, 0, 0])
    const [reportID, setReportId] = useState(0)

    const [showReportGenerated, setShowReportGenerated] = useState(false);
    const [showConfigurator, setShowConfigurator] = useState(false)
    const [showReportCover, setShowReportCover] = useState(false)
    const [generatingReport, setGeneratingReport] = useState(false)
    const [reportConfig, setReportConfig] = useState(null)

    const [showROIOverviewCard, setShowROIOverviewCard] = useState(true)
    const [showROIBarChart, setShowROIBarChart] = useState(true)
    const [showROIGraphical, setShowROIGraphical] = useState(true)
    const [showROITabular, setShowROITabular] = useState(true)
    const [showROISummary, setShowROISummary] = useState(true)

    const [showTitleHover, setShowTitleHover] = useState(false)
    const [showReportError, setShowReportError] = useState(false)

    const [subscription, setSubscription] = useState(null)

    useEffect(() => {
        window.addEventListener('scroll', handleFilterScroll)
        if(!params.reportId) {
            let response = comments_api.createRoiCommentId();
            response.then(response => {
                setReportId(response.data.id)
            }).catch(err => console.log(err))
        } else {
            setReportId(params.reportId)
        }
    }, []);

    const handleFilterScroll = (ev) => {
        if(!ev) return;
        let elem = document.getElementById('filter-open')
        if (elem) {
            elem.style.top = `${Math.max(323 - window.scrollY, 30)}px`
        }
    }

    const getValidTeams = () => {
        let response = reports_api.getValidROITeams();
        response.then(response => {
            formatFilterList(response.data.teams);
        }).catch(err => console.log(err))
    }

    const formatFilterList = (teams) => {
        let c = []
        let fl = []
        // Group organisations by id + demo flag (not name) so organisations
        // sharing a name are kept separate
        for(const team of teams) {
            if(!c.some(x => x.id === team.organisation_id && x.demo === !!team.demo)) {
                c.push({
                    "id": team.organisation_id,
                    "demo": !!team.demo,
                    "name": team.organisation_name,
                    "colour": team.organisation_colour
                })

            }
        }

        for(const organisation of c) {
            let _teams = []
            for(const team of teams) {
                if(organisation.id === team.organisation_id && organisation.demo === !!team.demo) {
                    let _org = {
                        "team_id": team.team_id,
                        "demo": team.demo,
                        "team_name": team.team_name,
                        "organisation_id": team.organisation_id,
                        "organisation_name": team.organisation_name,
                        "organisation_colour": team.organisation_colour
                    }
                    _teams.push(_org)
                    fl.push(_org)
                }
            }
            organisation.teams = _teams
        }

        let response = reports_api.getROIFilter()
        response.then(response => {
            let filter_load = []
            for(const filterItem of response.data) {
                for(const team of fl) {
                    if((filterItem.team_id === team.team_id) && (!!filterItem.demo === !!team.demo) && (filterItem.team_name === team.team_name)) {
                        filter_load.push(team)
                        break;
                    }
                }
            }
            if(filter_load.length) {
                setFilterSelected(filter_load)
                setSelectedTeams(filter_load)
            } else {
                setFilterSelected(fl)
                setSelectedTeams(fl)
            }
        }).catch(err => console.log(err))
        setFilterList(c)
    }

    const getROIData = () => {
        if(!selectedTeams || !selectedTeams.length) return
        let st = []
        for(const team of selectedTeams) {
            st.push({
                "team_id": team.team_id,
                "demo": team.demo
            })
        }
        let response = reports_api.getROIData(st)
        response.then(response => {
            setGraphicalData(response.data.graphical)
            setTabularData(response.data.tabular)
            setBarChartData(response.data.bar_chart)
            setTitleData(response.data.title_data)
            setCoachData(response.data.coach_data)
            setBenchmark(response.data.benchmark)
        }).catch(err => console.log(err))
    }

    useEffect(() => {
        getValidTeams()
    }, []);

    useEffect(() => {
        if(!selectedTeams || !selectedTeams.length) return;
        getROIData()
    }, [selectedTeams]);

    useEffect(() => {
        let all_teams = []
        for(const organisation of filterList) {
            for(const team of organisation.teams) {
                all_teams.push(team)
            }
        }
        if(all_teams.length === filterSelected.length && filterSelected.length > 0) {
            setSelectState(2)
        } else if(filterSelected.length) {
            setSelectState(1)
        } else {
            setSelectState(0)
        }
    }, [filterSelected])

    const handleBackClick = (ev) => {
        if(!ev) return;
        if (window.history.length > 1) {
            navigate(-1)
        } else {
            navigate('/dashboard')
        }
    }

    const handleSelectAll = (ev) => {
        if(!ev) return;
        let temp_list = []
        if(selectState !== 2) {
            for(const organisation of filterList) {
                for(const team of organisation.teams) {
                    temp_list.push(team)
                }
            }
        }
        setFilterSelected(temp_list)
    }

    const updateFilterSelected = (teams) => {
        let s = [...filterSelected]

        for(const team of teams) {
            let was_updated = false
            for(let i = 0; i < filterSelected.length; i++) {
                if((filterSelected[i].team_id === team.team_id) && (filterSelected[i].demo === team.demo)) {
                    s.splice(i, 1)
                    was_updated = true
                    break;
                }
            }
            if(!was_updated) s.push(team)
        }
        setFilterSelected(s)
    }

    const handleFilterReset = (ev) => {
        if(!ev) return;
        window.location.reload()
    }

    const handleFilterSave = (ev) => {
        if(!ev) return;
        setSelectedTeams(filterSelected)
        let response = reports_api.saveROIFilter(filterSelected)
        response.catch(err => console.log(err))
        let elem = document.getElementById('filter-open')
        if(elem) {
            elem.style.display = "none"
        }
    }

    const handleOpenFilter = (ev) => {
        if(!ev) return;
        let elem = document.getElementById('filter-open')
        if (elem) {
            elem.style.display = "block"
        }
    }

    const handleCloseFilter = (ev) => {
        if(!ev) return;
        let elem = document.getElementById('filter-open')
        if(elem) {
            elem.style.display = "none"
        }
    }

    const OpenConfigurator = (ev) => {
        if(!ev) return;
        setShowConfigurator(true)
    }

    const CloseConfigurator = (ev) => {
        if(!ev) return;
        setShowConfigurator(false)
    }

    const HandleConfiguratorGenerate = () => {
        setShowConfigurator(false)
        setShowReportCover(true)
    }

    const getSubscription = () => {
        let response = profile_api.getSubscription();
        response.then(response => {
            setSubscription(response.data.subscription.type);
        }).catch(() => {});
    };

    useEffect(() => {
        getSubscription();
    }, []);

    const finaliseReport = (sections) => {
        let report_details = {
            "client_name": "N/A",
            "team_name": "N/A",
            "comparing_surveys": "N/A",
            "tm_count": "N/A",
            "tl_count": "N/A",
            "st_count": "N/A",
            "survey_id": null,
            "team_id": null,
        }

        let response = reports_api.finaliseReport('roi', report_details, {}, reportConfig, sections);
        response.then(() => {
            setGeneratingReport(false);
            setShowReportCover(false);
            setShowReportGenerated(true);
        }).catch(err => {
            console.log(err);
            setGeneratingReport(false);
            setShowReportCover(false);
            setShowReportError(true)
        })
    }

    useEffect(() => {
        if(!showReportCover) return;
        setGeneratingReport(true)
    }, [showReportCover])

    useEffect(() => {
        if(!generatingReport) return;

        let cancelled = false;

        let section_ids = {}
        let ids = ["roi-title-card", "roi-bar-chart", "roi-graphical", "roi-tabular", "roi-coach-performance"]
        let current_idx = 0

        for (const pdf_section of ids) {
            switch (pdf_section) {
                case "roi-title-card":
                    if(showROIOverviewCard) section_ids[`${current_idx}`] = "roi-title-card";
                    current_idx += 1;
                    break;
                case "roi-bar-chart":
                    if(showROIBarChart) section_ids[`${current_idx}`] = "roi-bar-chart";
                    current_idx += 1;
                    break;
                case "roi-graphical":
                    if(showROIGraphical) section_ids[`${current_idx}`] = "roi-graphical";
                    current_idx += 1;
                    break;
                case "roi-tabular":
                    if(showROITabular) section_ids[`${current_idx}`] = "roi-tabular";
                    current_idx += 1;
                    break;
                case "roi-coach-performance":
                    if(showROISummary) section_ids[`${current_idx}`] = "roi-coach-performance";
                    break;
            }
        }

        (async () => {
            await waitForLayout();

            if (cancelled) return;

            if (!Object.keys(section_ids).length) {
                finaliseReport({});
                return;
            }

            try {
                const generated_sections = {};

                await Promise.all(
                    Object.entries(section_ids).map(async ([key, value]) => {
                        const elem = document.getElementById(value);
                        const canvas = await captureElementAsCanvas(elem);
                        generated_sections[key] = canvasToA4PdfDataUri(canvas);
                    })
                );

                if (cancelled) return;
                finaliseReport(generated_sections);
            } catch {
                setGeneratingReport(false);
                setShowReportCover(false);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [generatingReport]);

    return (
        <>
            <div className={`roi-report-page-background-container${generatingReport ? " pdf-capture-active" : ""}`}>
                <div className={`roi-report-page-container${generatingReport ? " pdf-capture-container" : ""}`}>
                    <div className="link" onClick={handleBackClick}>
                        <img className={"back-arrow-classname"} src={back_arrow} alt={"Back Arrow"}/>
                    </div>
                    <div className="roi-report-page-title-container">
                        <div className="summary-title no-border">
                            TEAM COACHING PERFORMANCE SUMMARY
                            <img src={info} alt="Info"
                                 onMouseOver={() => setShowTitleHover(true)}
                                 onMouseLeave={() => setShowTitleHover(false)}
                            />
                            {showTitleHover ?
                                <div className="dashboard-roi-title-hover" style={{top: 62, left: 641, width: 400}}>
                                    <div className="dashboard-roi-title-hover-triangle-outer">
                                        <div className="dashboard-roi-title-hover-triangle-inner"/>
                                    </div>
                                    <div className="dashboard-roi-title-hover-text regular">
                                        This page displays a detailed analysis of performance over time of all
                                        qualifying teams*  for you and any selected Co-Coaches over the period of the
                                        team coaching engagement(s). Use the filter bar on the left hand side to select
                                        the organisations and teams you wish to include in your summary.
                                        <br/><br/>
                                        *For teams to be included in this analysis, at least two of the team
                                        participants must have completed both an initial and end point survey.
                                    </div>
                                </div> : null
                            }
                        </div>
                        {graphicalData && coachData && tabularData ?
                            <div className="pdf-download-button-container" onClick={OpenConfigurator}>
                                <img src={pdf_download}/>
                            </div>
                            : null }
                    </div>
                    <div className="roi-report-page-body-container">
                        <div className="roi-report-page-filter-container">
                            <div className="roi-report-filter-button" onClick={handleOpenFilter}>
                                <div className="roi-report-filter-text bold">
                                    Team Selector
                                    <img src={filter_arrow} alt="Filter" style={{left: -12}}/>
                                </div>
                                <div className="roi-report-filter-button-img">
                                    <img src={filter} alt="Filter"/>
                                </div>
                            </div>
                            <div className="roi-report-filter-open-container" id="filter-open">
                                <div className="roi-report-filter-open-top-row bold">
                                    <div className="roi-report-filter-open-top-row-text">Team Selector</div>
                                    <div className="roi-report-filter-open-top-row-text large"
                                         onClick={handleCloseFilter}>
                                        <img src={filter_arrow} alt="Close"/>
                                    </div>
                                </div>
                                <div className="roi-report-filter-subtext regular">
                                    Select Organisations and Teams to include in the summary
                                </div>
                                <div className="roi-filter-all-select-row">
                                    <div className={`roi-filter-selected-box ${selectState > 0 ? "filled" : ""}`}
                                         onClick={handleSelectAll}>
                                        {selectState === 2 ? "✓" : selectState === 1 ? "-" : ""}
                                    </div>
                                    <div className="roi-filter-all-select-text bold">All</div>
                                </div>
                                {filterList.map((organisation, idx) => {
                                    return <ROIFilterOrganisationRow organisation={organisation} key={idx} selected={filterSelected}
                                                                update={updateFilterSelected.bind(this)}/>
                                })}
                                <div className="roi-filter-buttons-container">
                                    <div className="roi-filter-button" onClick={handleFilterReset}>Reset</div>
                                    <div className="roi-filter-button filled" onClick={handleFilterSave}>Save</div>
                                </div>
                            </div>
                        </div>
                        <div className="roi-report-page-body">
                            <div className="roi-report-body-section" id="roi-title-card">
                                <ROITitleCard teams={selectedTeams} data={titleData} generatingReport={generatingReport}/>
                                <CoachCommentaryContainer context_id={reportID} section_id="roi-title-card"
                                                          generatingReport={generatingReport} subscription={subscription}/>
                            </div>
                            <div className="roi-report-body-section" id="roi-bar-chart">
                                <ROIBarChart data={barChartData} benchmark={benchmark} teams={selectedTeams}/>
                                <CoachCommentaryContainer context_id={reportID} section_id="roi-bar-chart"
                                                          generatingReport={generatingReport} subscription={subscription}/>
                            </div>
                            <div className="roi-report-body-section" id="roi-graphical">
                                <ROIGraphical data={tabularData} pillars={graphicalData} teams={selectedTeams}/>
                                <CoachCommentaryContainer context_id={reportID} section_id="roi-graphical"
                                                          generatingReport={generatingReport} subscription={subscription}/>
                            </div>
                            <div className="roi-report-body-section" id="roi-tabular">
                                <ROITabular data={tabularData} generatingReport={generatingReport} teams={selectedTeams} />
                                <CoachCommentaryContainer context_id={reportID} section_id="roi-tabular"
                                                          generatingReport={generatingReport} subscription={subscription}/>
                            </div>
                            <div className="roi-report-body-section" id="roi-coach-performance">
                                <ROICoachPerformance data={coachData} generatingReport={generatingReport} teams={selectedTeams} />
                                <CoachCommentaryContainer context_id={reportID} section_id="roi-coach-performance"
                                                          generatingReport={generatingReport} subscription={subscription}/>
                            </div>
                        </div>
                    </div>
                </div>
                {showConfigurator ?
                    <ROIReportConfigurator generate={HandleConfiguratorGenerate.bind(this)}
                                           close={CloseConfigurator.bind(this)}
                                           saveConfig={setReportConfig.bind(this)}
                                           showOverview={showROIOverviewCard}
                                           setShowOverview={setShowROIOverviewCard.bind(this)}
                                           showBarChart={showROIBarChart}
                                           setShowBarChart={setShowROIBarChart.bind(this)}
                                           showGraphical={showROIGraphical}
                                           setShowGraphical={setShowROIGraphical.bind(this)}
                                           showTabular={showROITabular}
                                           setShowTabular={setShowROITabular.bind(this)}
                                           showSummary={showROISummary}
                                           setShowSummary={setShowROISummary.bind(this)}
                    />
                    : null
                }
            </div>
            <div className="report-generation-cover bold" style={{display: showReportCover ? "flex" : "none"}}>
                <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                Please wait, your report is being generated
            </div>
            {showReportError ?
                <>
                    <div className="page-mask" onClick={() => setShowReportError(false)}/>
                    <div className="report-error-popup">
                        <div className="report-error-title bold">Something Went Wrong</div>
                        <div className="report-error-description regular">
                            Failed to generate report. Please try again later.
                        </div>
                        <div className="report-error-button bold" onClick={() => setShowReportError(false)}>
                            OK
                        </div>
                    </div>
                </> : null
            }
            {showReportGenerated &&
                <>
                    <div className="page-mask" onClick={() => setShowReportGenerated(false)}/>
                    <div className="report-error-popup">
                        <div className="report-error-title bold">Report Generated</div>
                        <div className="report-error-description regular">
                            Your report has been generated and has been added to the reports table.
                            Click Reports in the menu to see this table.
                        </div>
                        <div className="report-error-button bold" onClick={() => setShowReportGenerated(false)}>
                            OK
                        </div>
                    </div>
                </>
            }

        </>
    )
}

export default ROIReport